// extracted by mini-css-extract-plugin
export default {"textContainer":"Home_textContainer__+crkK","chevronDown":"Home_chevronDown__lNrLq","landing":"Home_landing__iEyCP"};